import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const linkSearchSchema = z.object({
  token: z.string().optional(),
  api_url: z.string().optional(),
  device_name: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/(wonda)/_wonda/link")({
  validateSearch: zodValidator(linkSearchSchema),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/cli-auth",
      search: {
        token: search.token,
        api_url: search.api_url,
        kind: "relay",
        device_name: search.device_name,
      },
    });
  },
});
